import { CrmMarketRegionFeaturePage } from "..";

/** 区域经营配置页面入口。 */
export function CrmMarketRegionPage() {
  return <CrmMarketRegionFeaturePage />;
}
